import type {ReactElement} from 'react';
import {useEffect, useRef, useState} from 'react';
import {motion} from 'framer-motion';
import type {CreditsModalContentProps} from './credits-modal-content.types';
import {CREDITS_MODAL_HEIGHT_TRANSITION} from './credits-modal-content.types';

export function CreditsModalContent({children}: CreditsModalContentProps): ReactElement {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [contentHeight, setContentHeight] = useState<number | null>(null);

  useEffect(() => {
    const element = contentRef.current;

    if (!element) {
      return undefined;
    }

    const observer = new ResizeObserver((): void => {
      setContentHeight(element.offsetHeight);
    });
    observer.observe(element);

    return (): void => {
      observer.disconnect();
    };
  }, []);

  return (
    <motion.div animate={{height: contentHeight ?? 'auto'}} transition={CREDITS_MODAL_HEIGHT_TRANSITION} style={{overflow: 'hidden'}}>
      <div ref={contentRef}>{children}</div>
    </motion.div>
  );
}
